import { TableHead } from "@/components/ui";

const startResizing = (e: React.MouseEvent) => {
  const startX = e.clientX;
  const th = e.currentTarget.parentElement!;
  const startWidth = th.offsetWidth;

  const onMouseMove = (moveEvent: MouseEvent) => {
    const newWidth = startWidth + (moveEvent.clientX - startX);
    th.style.width = `${newWidth}px`;
  };

  const onMouseUp = () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  };

  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);
};

const CustomTableHead = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => (
  <TableHead
    className={`text-primary bg-blue-50 text-[14px] font-semibold border-blue-50 border-r-1 border-t-1 w-[250px] whitespace-normal text-center p-1 ${
      className ?? ""
    }`}
  >
    {children}
    <div
      className="absolute right-0 top-0 h-full w-[5px] cursor-col-resize group-hover:bg-gray-300"
      onMouseDown={(e) => startResizing(e)}
    />
  </TableHead>
);

export default CustomTableHead;
